import {I18n} from "../LangUtil";
import KWT from "./KWT";
import BHR from "./BHR";
import OMN from "./OMN";
import DataStore from "@shared/services/DataStore";

const DEFAULT_TENANT = "KWT";
let TenantUtilsMap = {
  KWT: KWT,
  BHR: BHR,
  OMN: OMN
};

let TenantUtils = {
  getText(key){
    return I18n(key,this.getTenant());
  },
  getIdOpts(){
    return {
      label: I18n('g.lbl.civilid')
    }
  },
  getIdOptsPassport(){
    return {
      label: I18n('Passport Number')
    }
  },
  getMessages(){
    return {
      blackListedMsg: I18n('g.msg.blacklistedcustomer'),
      additionalRemittanceThxText: I18n('g.lbl.addthx')
    }
  },
  getTenantInfo(){
    return {
      name: I18n('g.lbl.almulla')
    }
  },
  getSupportInfo(){
    return {
      custPhone: DataStore.getData().customerCareDetails.custPhone,
      custEmail: DataStore.getData().customerCareDetails.custEmail,
      time: DataStore.getData().customerCareDetails.time
    }
  },
  getThankyouText(){
    return I18n('g.lbl.thx');
  },
  getMobilePrefix(){
    return "+965"
  },
  getLangs(){
    // 0 : Language key
    // 1 : boolean enable disable language,
    // 2 : language name
    return [
      ["en",true,"English"],
      ["ar",true,"العربية"],
      /**["bn",false,"বাংলা"],
      ["gu",false,"ગુજરાતી"],
      ["hi",false,"हिन्दी"],
      ["kn",false,"ಕನ್ನಡ"],
      ["ml",false,"മലയാളം"],
      ["mr",false,"मराठी"],
      ["np",false,"नेपाली"],
      ["si",false,"සිංහල"],
      ["ta",false,"தமிழ்"],
      ["tl",false,"Tagalog"],
      ["te",false,"తెలుగు"],
      ["ur",false,"اُردُو‬"]**/
    ]
  },
  getTenant(){
    // let tenant;
    // try{
    //   tenant = window.location.host.split(".")[0].split("-")[1].toUpperCase();
    //   console.log("lang====getTenant",tenant)
    // } catch (e){
    //   console.error(e);
    //   tenant = DEFAULT_TENANT;
    // }
    let href = window.location.href;
    return href.indexOf("omn") > -1 ? "OMN" : href.indexOf("bhr") > -1 ? "BHR" : "KWT";  }
};

let tenant;
let lang = "default";
try{
  let href = window.location.href;
  tenant = href.indexOf("omn") > -1 ? "OMN" : href.indexOf("bhr") > -1 ? "BHR" : "KWT";
  lang = window.localStorage.getItem("lang");
} catch (e){
  console.warn(e);
}
TenantUtils = {
  ...TenantUtils,
  ...tenant && TenantUtilsMap[tenant] ? TenantUtilsMap[tenant] : {}
};

export default TenantUtils;




